import {observable} from "mobx";
import {RelatorioService} from "../../../services";
import {getMensagemDeErro} from "../../../utils/functions";
import fileDownload from "../../comum/components/FileDownload";

export default class SolicitacaoStore {
    @observable erro;
    @observable carregando;
    @observable dados;

    constructor() {
        this.relatorioService = new RelatorioService();
    }

    onExportExcel = (filtro) => {
        this.carregando = true;
        this.erro = null;

        this.relatorioService.downloadSolicitacaoExcel(filtro).then(response => {
            
            const fileName = "RelatorioSolicitacoes" + filtro.dataInicial + "_" + filtro.dataFinal + "_" + filtro.tipoFiltroRelSolicitacoes +".xlsx";

            fileDownload(response.data, fileName);

            this.carregando = false;
        }).catch(error => {
            this.erro = "Nenhum resultado encontrado";
            this.carregando = false;
        });
    }
}
